'use client'

import { useSearchParams } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { useAction } from 'next-safe-action/hooks'
import { UseFormReturn } from 'react-hook-form'

import { signIn, TSignIn } from '@/entities/auth'
import { AUTH } from '@/shared/api'
import { useServerErrorHandler } from '@/shared/config/action'
import {
  setStorage,
  STORAGE_KEY,
  useSession,
  signInWithToken,
} from '@/shared/lib'

export const useSignIn = (form: UseFormReturn<TSignIn>) => {
  const session = useSession()

  const searchParams = useSearchParams()
  const redirect = searchParams?.get('redirect')

  const { handleServerError } = useServerErrorHandler(form)

  const t = useTranslations('login')

  const action = useAction(signIn, {
    onSuccess: async ({ data }) => {
      const { blocked, firebaseToken } = data ?? {}

      if (blocked) {
        setStorage(STORAGE_KEY.SHOW_BLOCKED_USER_DIALOG, 'true')
      }

      await session.update()

      if (firebaseToken) {
        await signInWithToken(firebaseToken)
      }

      if (redirect) {
        window.location.href = redirect
      } else {
        window.location.reload()
      }
    },
    onError: ({ error }) => {
      const { serverError } = error

      const isInvalidCredentials = serverError?.code === AUTH['001']
      const invalidCredentialsMessage = t('password_error_invalid_credentials')

      if (isInvalidCredentials) {
        handleServerError({
          ...serverError,
          data: {
            password: invalidCredentialsMessage,
          },
        })
      } else {
        handleServerError(serverError)
      }
    },
  })

  return action
}
